/* GabiPrime Theme – gp-main.js
   Shopify-Warenkorb (Drawer), Varianten, Galerie, Lightbox, Katalogfilter. */
(function () {
  'use strict';
  var cart = { items: [], item_count: 0, total_price: 0 };

  var moneyFmt;
  try { moneyFmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); } catch (e) { moneyFmt = null; }
  function money(n) { return moneyFmt ? moneyFmt.format(n) : n.toFixed(2).replace('.', ',') + ' €'; }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function api(url, body) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- Warenkorb (Shopify) ---------- */
  function loadCart() { return api('/cart.js').then(function (c) { cart = c; renderAll(); return c; }); }
  function addToCart(id, q) {
    return api('/cart/add.js', { items: [{ id: id, quantity: q }] }).then(loadCart).catch(function (e) {
      alert((e && (e.description || e.message)) || 'Dieser Artikel konnte nicht in den Warenkorb gelegt werden.');
      return loadCart();
    });
  }
  function setQty(key, q) { return api('/cart/change.js', { id: key, quantity: q }).then(function (c) { cart = c; renderAll(); }); }

  function itemHtml(i, withTotal) {
    var label = (i.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' · ');
    var img = i.image ? imgUrl(i.image, 240) : '';
    var line = money(i.final_line_price / 100);
    return '<li class="mini-item">' +
        '<a href="' + esc(i.url) + '" class="studio" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="240" height="300">' : '') +
        '</a><div>' +
          '<a class="mini-item__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          (label ? '<div class="mini-item__meta">' + esc(label) + '</div>' : '') +
          '<div class="mini-item__meta">' + money(i.final_price / 100) + ' pro Stück</div>' +
          '<div class="mini-item__row">' +
            '<div class="qty" data-cart-qty="' + esc(i.key) + '">' +
              '<button type="button" data-qty-minus aria-label="Menge verringern">−</button>' +
              '<label class="visually-hidden" for="q-' + esc(i.key) + '">Menge</label>' +
              '<input id="q-' + esc(i.key) + '" type="number" min="0" max="99" value="' + i.quantity + '" inputmode="numeric">' +
              '<button type="button" data-qty-plus aria-label="Menge erhöhen">+</button>' +
            '</div>' +
            '<button type="button" class="link-btn" data-cart-remove="' + esc(i.key) + '">Entfernen</button>' +
            (withTotal ? '' : '<strong>' + line + '</strong>') +
          '</div>' +
        '</div>' +
        (withTotal ? '<div class="mini-item__total">' + line + '</div>' : '') +
      '</li>';
  }

  function renderCartInto(target, opts) {
    if (!target) return;
    var list = cart.items || [];
    var body = $('[data-cart-items]', target);
    var foot = $('[data-cart-foot]', target);
    var empty = $('[data-cart-empty]', target);
    if (!list.length) {
      if (body) body.innerHTML = '';
      if (foot) foot.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    if (body) body.innerHTML = '<ul style="list-style:none;margin:0;padding:0">' + list.map(function (i) { return itemHtml(i, opts && opts.wide); }).join('') + '</ul>';
    $all('[data-cart-subtotal]', target).forEach(function (el) { el.textContent = money(cart.total_price / 100); });
  }

  function renderAll() {
    var count = cart.item_count || 0;
    $all('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $all('[data-cart-button]').forEach(function (el) { el.setAttribute('aria-label', 'Warenkorb, ' + count + ' Artikel'); });
    renderCartInto($('#CartDrawer'));
    renderCartInto($('[data-cart-page]'), { wide: true });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { setQty(rm.getAttribute('data-cart-remove'), 0); return; }
    var wrap = e.target.closest('[data-cart-qty]');
    var btn = e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (wrap && btn) {
      var input = $('input', wrap);
      var q = parseInt(input.value, 10) || 0;
      q = btn.hasAttribute('data-qty-plus') ? Math.min(99, q + 1) : Math.max(0, q - 1);
      input.value = q;
      setQty(wrap.getAttribute('data-cart-qty'), q);
    }
  });
  document.addEventListener('change', function (e) {
    var wrap = e.target.closest('[data-cart-qty]');
    if (wrap) {
      var q = Math.max(0, Math.min(99, parseInt(e.target.value, 10) || 0));
      setQty(wrap.getAttribute('data-cart-qty'), q);
    }
  });

  /* ---------- Drawer ---------- */
  var lastFocus = null;
  function openDrawer() {
    var d = $('#CartDrawer'), o = $('#CartOverlay');
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); if (o) o.classList.add('is-open'); });
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    $all('[data-cart-button]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var close = $('[data-drawer-close]', d);
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = $('#CartDrawer'), o = $('#CartOverlay');
    if (!d) return;
    d.classList.remove('is-open');
    if (o) o.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    $all('[data-cart-button]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { d.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-button]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]') || e.target.id === 'CartOverlay') closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = $('#CartDrawer'); if (d && d.classList.contains('is-open')) closeDrawer(); }
  });

  /* ---------- Mobiles Menü ---------- */
  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('#HeaderNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    var p = window.GP_PRODUCT;
    if (!p || !p.variants.length) { initGallery(root, p || { images: [] }); return; }
    var current = p.variants[0];
    var priceEl = $('[data-price]', root);
    var addBtn = $('[data-add]', root);
    var addLabel = $('[data-add-label]', root);
    var note = $('[data-added-note]', root);
    var qtyInput = $('[data-qty] input', root);

    function selected() {
      return $all('[data-option]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function find(values) {
      return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); })[0];
    }
    function matchesPrefix(v, values, upto) {
      for (var i = 0; i <= upto; i++) { if (v.options[i] !== values[i]) return false; }
      return true;
    }
    function update(changedIdx) {
      var fieldsets = $all('[data-option]', root);
      var values = selected();
      if (values.length && !find(values)) {
        var keep = typeof changedIdx === 'number' ? changedIdx : 0;
        var alt = p.variants.filter(function (v) { return matchesPrefix(v, values, keep); })[0];
        if (alt) {
          fieldsets.forEach(function (fs, idx) {
            $all('input', fs).forEach(function (input) { input.checked = input.value === alt.options[idx]; });
          });
          values = selected();
        }
      }
      fieldsets.forEach(function (fs, idx) {
        var lbl = $('[data-option-value]', fs);
        if (lbl) lbl.textContent = values[idx] || '';
        $all('input', fs).forEach(function (input) {
          var test = values.slice(); test[idx] = input.value;
          var possible = p.variants.some(function (v) { return matchesPrefix(v, test, idx); });
          input.classList.toggle('is-unavailable', !possible);
        });
      });
      var v = values.length ? find(values) : p.variants[0];
      current = v || null;
      if (v) {
        if (priceEl) priceEl.textContent = money(v.price);
        addBtn.disabled = false;
        addLabel.textContent = 'In den Warenkorb';
      } else {
        addBtn.disabled = true;
        addLabel.textContent = 'Diese Kombination ist nicht erhältlich';
      }
    }
    $all('[data-option]', root).forEach(function (fs, idx) {
      $all('input', fs).forEach(function (i) { i.addEventListener('change', function () { update(idx); }); });
    });

    var qtyWrap = $('[data-qty]', root);
    if (qtyWrap) {
      qtyWrap.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        var q = parseInt(qtyInput.value, 10) || 1;
        q = b.hasAttribute('data-qty-plus') ? Math.min(99, q + 1) : Math.max(1, q - 1);
        qtyInput.value = q;
      });
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!current) return;
        var q = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
        addBtn.disabled = true;
        addToCart(current.id, q).then(function () {
          addBtn.disabled = false;
          if (note) note.textContent = '✓ ' + q + ' × hinzugefügt';
          openDrawer();
        });
      });
    }
    update();
    initGallery(root, p);
  }

  /* ---------- Galerie & Lightbox ---------- */
  function initGallery(root, p) {
    var main = $('[data-main-image]', root);
    var counter = $('[data-gallery-count]', root);
    var thumbs = $all('[data-thumb]', root);
    var index = 0;
    var total = p.images.length;
    if (!main || !total) return;
    var box = $('#Lightbox');
    var boxImg = box ? $('img', box) : null;
    var boxCount = box ? $('[data-lightbox-count]', box) : null;

    function show(i) {
      index = (i + total) % total;
      var url = p.images[index];
      main.classList.add('is-loading');
      main.onload = function () { main.classList.remove('is-loading'); };
      main.src = imgUrl(url, 1200);
      main.srcset = [600, 900, 1200, 1600].map(function (w) { return imgUrl(url, w) + ' ' + w + 'w'; }).join(', ');
      main.alt = p.title + ' – Bild ' + (index + 1) + ' von ' + total;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      if (counter) counter.textContent = (index + 1) + ' / ' + total;
      if (box && box.open) showBox();
    }
    function showBox() {
      boxImg.src = imgUrl(p.images[index], 2000);
      boxImg.alt = p.title + ' – Bild ' + (index + 1);
      if (boxCount) boxCount.textContent = (index + 1) + ' / ' + total;
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    $all('[data-gallery-prev]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); show(index - 1); }); });
    $all('[data-gallery-next]', root).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); }); });

    var stage = $('[data-stage]', root);
    if (stage && box && typeof box.showModal === 'function') {
      stage.addEventListener('click', function () { showBox(); box.showModal(); });
      stage.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showBox(); box.showModal(); } });
      $('[data-lightbox-close]', box).addEventListener('click', function () { box.close(); });
      $('[data-lightbox-prev]', box).addEventListener('click', function () { show(index - 1); });
      $('[data-lightbox-next]', box).addEventListener('click', function () { show(index + 1); });
      box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('lightbox__inner')) box.close(); });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(index - 1);
        if (e.key === 'ArrowRight') show(index + 1);
      });
    }
    var startX = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
        startX = null;
      });
    }
  }

  /* ---------- Schnell in den Warenkorb ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    addToCart(Number(b.getAttribute('data-quick-add')), 1).then(function () { b.disabled = false; openDrawer(); });
  });

  /* ---------- Katalog: Suche & Sortierung ---------- */
  function initCatalog(root) {
    var grid = $('[data-catalog-grid]', root);
    var items = $all('[data-item]', grid);
    var search = $('[data-catalog-search]', root);
    var sort = $('[data-catalog-sort]', root);
    var count = $('[data-catalog-count]', root);
    var empty = $('[data-catalog-empty]', root);
    function norm(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    function apply() {
      var q = search ? norm(search.value.trim()) : '';
      var visible = 0;
      items.forEach(function (el) {
        var hit = !q || norm(el.getAttribute('data-search')).indexOf(q) > -1;
        el.hidden = !hit;
        if (hit) visible++;
      });
      if (sort) {
        var mode = sort.value;
        var sorted = items.slice().sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-price')), pb = parseFloat(b.getAttribute('data-price'));
          var ia = parseInt(a.getAttribute('data-index'), 10), ib = parseInt(b.getAttribute('data-index'), 10);
          if (mode === 'price-asc') return pa - pb || ia - ib;
          if (mode === 'price-desc') return pb - pa || ia - ib;
          if (mode === 'name') return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'), 'de');
          return ia - ib;
        });
        sorted.forEach(function (el) { grid.appendChild(el); });
      }
      if (count) count.textContent = visible + (visible === 1 ? ' Produkt' : ' Produkte');
      if (empty) empty.hidden = visible > 0;
    }
    if (search) search.addEventListener('input', apply);
    if (sort) sort.addEventListener('change', apply);
    apply();
  }

  /* ---------- Start ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    $all('[data-product]').forEach(initProduct);
    $all('[data-catalog]').forEach(initCatalog);
    loadCart();
  });
})();
